export function CreativeCardSkeleton() {
  return (
    <div className="relative overflow-hidden rounded-xl bg-white border border-gray-200/50">
      {/* Image area */}
      <div className="relative w-full aspect-square overflow-hidden bg-gray-100/20">
        <div className="h-full w-full bg-gray-200 animate-pulse" />
        {/* Format badge skeleton */}
        <div className="absolute top-2.5 right-2.5 px-2 py-0.5 rounded-md bg-gray-300/50 backdrop-blur-sm">
          <div className="h-3 w-8 bg-gray-300 rounded animate-pulse" />
        </div>
      </div>
      
      {/* Footer with product name */}
      <div className="px-3 py-2.5 flex items-center gap-2">
        <div className="h-5 w-5 rounded-full overflow-hidden bg-gray-200/50 border border-gray-200/30 flex-shrink-0 animate-pulse" />
        <div className="h-4 w-3/4 bg-gray-200 rounded animate-pulse" />
      </div>
    </div>
  );
}

